<template>
  <!-- Las vistas técnicas de superadmin no tienen metadata en
       m_modules_permissions; por eso reciben su resumen como props. -->
  <div class="static-view-heading d-none d-md-flex">
    <span class="static-view-heading__icon"><AppIcon :name="icon" /></span>
    <p>{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.static-view-heading {
  align-items: center;
  gap: 8px;
  min-height: 36px;
}
.static-view-heading__icon {
  align-items: center;
  background: var(--app-color-primary-soft);
  border-radius: 8px;
  color: var(--app-color-primary);
  display: inline-flex;
  flex: 0 0 28px;
  font-size: 0.85rem;
  height: 28px;
  justify-content: center;
  width: 28px;
}
.static-view-heading p {
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-sm);
  font-weight: var(--app-font-medium);
  margin: 0;
}
</style>
